// extracted by mini-css-extract-plugin
module.exports = {"chosenCategoryGrid":"ChosenCategoryGrid_chosenCategoryGrid__kcP3Z","ViewedSectionSecondary__3videos":"ChosenCategoryGrid_ViewedSectionSecondary__3videos__33HlR"};